import Member from '@/bundles/Members/models/Member';
import Role from '@/bundles/Roles/models/Role';

import actions from './actions';
import mutations from './mutations';

export interface IFiltersDataState {
  markets: ReadonlyArray<{ name: string }>;
  isLoaded: boolean;
  members: ReadonlyArray<Member>;
  isMembersLoaded: boolean;
  adminRoles: ReadonlyArray<Role>;
  isAdminRolesLoaded: boolean;
}

const state = (): IFiltersDataState => ({
  markets: [],
  isLoaded: false,
  members: [],
  isMembersLoaded: false,
  adminRoles: [],
  isAdminRolesLoaded: false,
});

export default {
  namespaced: true,
  state,
  getters: {},
  actions,
  mutations,
}
